<template>
  <div v-if="type === 'default'" class="chk-wrap" :class="[{'hide-label': hideLabel}, customClass]">
    <input
      type="checkbox"
      :id="inputId"
      :name="name"
      :checked="checked"
       @mousedown="handleCheckboxMouseDown"
      @change="handleCheckboxChange"
      @click="handleCheckboxClick"
      :disabled="disabled"
      :required="required"
      class="chk-hidden"
    />
    <label :for="inputId" :class="['inp-check', {'a11y-blind': hideLabel}, labelClass]">
      <span v-if="props.showTextBefore" :class="textClass">{{ props.text }}</span>
      {{ label }}
      <span v-if="props.showTextAfter" :class="textClass">{{ props.text }}</span>
      <slot />
    </label>
  </div>
  <!-- 서브페이지 타이틀 -->
  <div v-if="type === 'checkTitle'" class="chk-wrap">
    <input
      type="checkbox"
      :id="inputId"
      :name="name"
      :checked="checked"
      @change="handleCheckboxChange"
      :disabled="disabled"
      class="chk-hidden"
    />
    <label v-if="label" :for="inputId" :class="['inp-check', {'a11y-blind': hideLabel}, labelClass]">
      {{ label }}<span class="text-green">{{ num }}</span>{{ unit }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue'

type InputType = 'default' | 'checkTitle'

const inputId = useId()

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  hideLabel: {
    type: Boolean,
    default: false
  },
  customClass: {
    type: String,
    default: ''
  },
  labelClass: {
    type: String,
    default: ''
  },
  type: {
    type: String as () => InputType,
    default: 'text' as InputType,
    validator: (value: string):value is InputType => ['default', 'checkTitle'].includes(value)
  },
  name: {
    type: String,
    default: ''
  },
  checked: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  checkLabel: {
    type: String,
    default: ''
  },
  showTextBefore: {
    type: Boolean,
    default: false
  },
  showTextAfter: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  },
  textClass: {
    type: String,
    default: ''
  },
  num: {
    type: Number,
    default: 0
  },
  unit: {
    type: String,
    default: '건'
  },
  spanShowLabel: {
    type: Boolean,
    required: false,
    default: true
  },
  spanA11yLabel: {
    type: Boolean,
    required: false,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
})

const emit = defineEmits<{
  (e: 'update:checked', value: boolean): void
  (e: 'change', value: boolean): void
  (e: 'click', value: MouseEvent): void
  (e: 'mousedown', value: MouseEvent): void
}>()

const handleCheckboxChange = (e: Event) => {
  const target = e.target as HTMLInputElement | null

  if (target) {
    emit('update:checked', target.checked);
    emit('change', target.checked);
  }
}

const handleCheckboxClick = (e: MouseEvent) => {
  emit('click', e)
}

const handleCheckboxMouseDown = (e: MouseEvent) => {
  emit('mousedown', e)
}
</script>

<style lang="scss" scoped>
</style>